import { Scope, Attributor, ClassAttributor as ClassAttributor$1, StyleAttributor as StyleAttributor$1 } from '../../../../node_modules/parchment/dist/parchment.js';

const config = {
  scope: Scope.BLOCK,
  whitelist: ['rtl']
};
const DirectionAttribute = new Attributor('direction', 'dir', config);
const DirectionClass = new ClassAttributor$1('direction', 'ql-direction', config);
const DirectionStyle = new StyleAttributor$1('direction', 'direction', config);

export { DirectionAttribute, DirectionClass, DirectionStyle };
